import { createContractRequest } from './helper';
export const getOffersBlobOverviewSearch = createContractRequest({
    route: '/contract/offers/blob/overview/search',
    method: 'get',
    source: 'data',
});
